<div>
  Apdex score (<a href="/projects/{{ project.id }}/edit" target="_self"
    >T = {{ project.apdexThreshold }} s</a
  >)<!DOCTYPE html>
  <ng-template #apdexTooltip>
    <ab-apdex-tooltip-text></ab-apdex-tooltip-text>
  </ng-template>
  <div
    class="card-tooltip"
    [ngbTooltip]="apdexTooltip"
    container="body"
    closeDelay="2000"
  >
    <span class="glyphicon glyphicon-question-circle glyphicon--blue"></span>
  </div>
  <h1 class="ab-card__data" *ngIf="!loading">
    {{ (apdexScore || 0).toFixed(2) }}
    <ab-trend
      class="ab-card__trend"
      *ngIf="apdexScoreList"
      [countList]="apdexScoreList"
      [dur]="dur"
      [statType]="'apdex score'"
      [performanceTrend]="true"
      [increasePositive]="true"
    ></ab-trend>
  </h1>
  <div *ngIf="loading">
    <ab-spinner-inline></ab-spinner-inline>
  </div>
</div>
